export const WIDGETS_NAMESPACE = ['report', 'widgets'];
